import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { secretKey } from "../.././data";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import { isArray } from "util";
import EditPelnSub from "./editPelnSub.js";
import EditClientAdditionalData from "./editClientAdditionalData.js";

const MySwal = withReactContent(Swal2);

const AddAggr = (props) => {
  const [template, setTemplate] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [letters, setLetters] = useState([]);
  const [mail, setMail] = useState(props.leadData.mail);
  const [phone, setPhone] = useState(props.leadData.phone);
  const [clientsE, setClientsE] = useState(
    props.leadData.aggName
      ? props.leadData.aggName.split(",")
      : props.leadData.name.split(",")
  );
  const [showEditClientAdditionalData, setShowEditClientAdditionalData] =
    useState(false);
  const [additionalData, setAdditionalData] = useState(
    props.leadData.aggAdditionalData ? props.leadData.aggAdditionalData : ""
  );
  const [aggValue, setAggValue] = useState(
    props.leadData.aggValue ? props.leadData.aggValue : ""
  );
  const [aggInstallment, setAggInstallment] = useState(
    props.leadData.aggInstallment ? props.leadData.aggInstallment : ""
  );
  const [aggSfValue, setAggSfValuet] = useState(
    props.leadData.aggSFValue ? props.leadData.aggSFValue : ""
  );
  const [aggSfUgValue, setAggSfUgValue] = useState(
    props.leadData.aggSFUgValue ? props.leadData.aggSFUgValue : ""
  );
  const [aggFirstPayDate, setAggFirstPayDate] = useState(
    props.leadData.aggFirstPayDate ? props.leadData.aggFirstPayDate : ""
  );
  const [aggCreditValue, setAggCreditValue] = useState(
    props.leadData.aggCreditValue ? props.leadData.aggCreditValue : ""
  );
  const [aggCreditNumber, setAggCreditNumber] = useState(
    props.leadData.aggCreditNumber ? props.leadData.aggCreditNumber : ""
  );
  const [aggCreditDate, setAggCreditDate] = useState(
    props.leadData.aggCreditDate ? props.leadData.aggCreditDate : ""
  );

  const [bank, setBank] = useState(
    props.leadData.bank ? props.leadData.bank : ""
  );
  const [bankNext, setBankNext] = useState("nie dotyczy");

  const [banksAggr, setBanksAggr] = useState([]);
  const [banksAggrNew, setBanksAggrNew] = useState([]);
  const [banks, setBanks] = useState([]);
  const [bankAddressDb, setBankAddressDb] = useState("");
  const [bankAddressDbAll, setBankAddressDbAll] = useState("");

  const fetchBanksAggr = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBanksAggr", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBanksAggr(data);
        setBanksAggrNew(data.filter((el) => el.bank === bank));
        fetchBankAddress();
      })
      .catch((error) => {});
  };

  const fetchBankAddress = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBankAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var data = "";

          if (el.addressNew) {
            data = JSON.parse(el.addressNew);
          } else {
            data = {
              street: "",
              number: "",
              postCode: "",
              city: "",
            };
          }

          var addressTxt =
            data.street +
            " " +
            data.number +
            ", " +
            data.postCode +
            " " +
            data.city;

          if (!el.addressNew) {
            addressTxt = "";
          }

          var obj = {
            id: el.id,
            nameSelect: el.nameSelect,
            nameLetter: el.nameLetter,
            bankKRS: el.bankKRS,
            address: addressTxt,
            addressNew: data,
          };

          arr.push(obj);
        });

        setBankAddressDbAll(arr);
        setBankAddressDb(
          arr.filter((el) => el.nameSelect === props.leadData.bank)[0]
        );
        fetchBanks();
      })
      .catch((error) => {});
  };

  const fetchBanks = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBanks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setBanks(data);
        fetchLetters();
      })
      .catch((error) => {});
  };

  const fetchLetters = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLettersAggr", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLetters(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getData = () => {
    setLoading(true);
    fetchBanksAggr();
  };

  useEffect(() => {
    getData();
  }, []);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleAddClient = (e) => {
    var check = e.target.value.split(" ").length > 1;
    if (check) {
      if (e.target.value === "") {
        return;
      } else {
        if (props.mode === "edit" || props.mode === "lead") {
          clientsE.push(e.target.value);
        } else {
          clientsE.push(e.target.value);
        }
        setName("");
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Imię i nazwisko niepoprawne",
      });
    }
  };

  const handleDeleteClient = (e) => {
    var newArray = [];

    newArray = clientsE.filter((el) => el !== e.target.value);
    setClientsE(newArray);
  };

  const closeEditAdditionalData = (e) => {
    setShowEditClientAdditionalData(false);
  };

  const generateName = () => {
    var name = "";

    if (props.mode === "edit" || props.mode === "lead") {
      if (clientsE.length === 1) {
        name = clientsE[0];
      } else {
        for (var i = 0; i < clientsE.length; i = i + 1) {
          name = name + clientsE[i] + (i === clientsE.length - 1 ? "" : ", ");
        }
      }
    } else {
      if (clientsE.length === 1) {
        name = clientsE[0];
      } else {
        for (var i = 0; i < clientsE.length; i = i + 1) {
          name = name + clientsE[i] + (i === clientsE.length - 1 ? "" : ", ");
        }
      }
    }

    return name;
  };

  const validate = () => {
    if (mail.length === 0 || phone.length === 0) {
      return false;
    }
    return true;
  };

  function loadFile(url, callback) {
    PizZipUtils.getBinaryContent(url, callback);
  }

  const getTemplateName = (value) => {
    if (value === "./asd23.docx") {
      return "Pełnomocnictwo";
    }
  };

  const getPesel = (el) => {
    if (additionalData === null || additionalData === undefined) {
      return "...........................";
    }
    var arr = additionalData.split("|");
    if (arr === undefined) {
      return "...........................";
    }
    if (
      arr.filter(
        (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
      ).length > 0
    ) {
      return arr
        .filter(
          (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
        )[0]
        .split(",")[1];
    } else {
      return "...........................";
    }
  };

  const getAddress = (el) => {
    if (additionalData === null || additionalData === undefined) {
      return "...........................";
    }
    var arr = additionalData.split("|");
    if (
      arr.filter(
        (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
      ).length > 0
    ) {
      return arr
        .filter(
          (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
        )[0]
        .split(",")[2] === undefined
        ? "..........................."
        : arr
            .filter(
              (x) =>
                x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
            )[0]
            .split(",")[2]
            .replaceAll(";", ",");
    } else {
      return "...........................";
    }
  };

  const getPetitionerData = () => {
    if (generateName() === undefined) {
      return "...........................";
    }
    var table =
      generateName().replaceAll("  ", "").split(",").length > 1
        ? generateName().replaceAll("  ", "").split(",")
        : generateName();
    var text = ``;

    var arr = [];

    if (isArray(table)) {
      table.map((el, index) => {
        arr.push({
          name: el.trim(),
          pesel: getPesel(el) !== "" ? getPesel(el) : ".....................",
          address:
            getAddress(el) !== "" ? getAddress(el) : ".....................",
        });
      });
      return arr;
    } else {
      return [
        {
          name: table,
          pesel: getPesel(table),
          address: getAddress(table),
        },
      ];
    }
  };

  const getMonthName = (month) => {
    if (month === 1) {
      return "stycznia";
    }
    if (month === 2) {
      return "lutego";
    }
    if (month === 3) {
      return "marca";
    }
    if (month === 4) {
      return "kwietnia";
    }
    if (month === 5) {
      return "maja";
    }
    if (month === 6) {
      return "czerwca";
    }
    if (month === 7) {
      return "lipca";
    }
    if (month === 8) {
      return "sierpnia";
    }
    if (month === 9) {
      return "września";
    }
    if (month === 10) {
      return "października";
    }
    if (month === 11) {
      return "listopada";
    }
    if (month === 12) {
      return "grudnia";
    }
  };

  const generateAggr1 = () => {
    var model = [];

    letters
      .filter((el) => el.type === "pełnomocnictwo")
      .map((element) => {
        model[element.link] = element.name;
      });

    MySwal.fire({
      title: "Wybierz wzór pełnomocnictwa",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wzór",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wzór");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var link = result.value;

        loadFile(link, function (error, content) {
          if (error) {
            throw error;
          }
          var zip = new PizZip(content);
          var doc = new Docxtemplater(zip, {
            paragraphLoop: true,
            linebreaks: true,
          });

          doc.setData({
            date:
              (new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : new Date().getDate()) +
              " " +
              getMonthName(new Date().getMonth() + 1) +
              " " +
              new Date().getFullYear() +
              " roku",
            hasName: clientsE.length === 0 ? false : true,
            hasNName: clientsE.length === 0 ? true : false,
            empty_name:
              clientsE.length === 0
                ? "Imię i nazwisko: ............................................................\nPESEL: ............................................................\n" +
                  "\n\n" +
                  "Imię i nazwisko: ............................................................\nPESEL: ............................................................\n"
                : "",
            petitioner_data: getPetitionerData(),
            pet_txt: clientsE.length > 1 ? "udzielamy" : "udzielam",
            pet_txt2: clientsE.length > 1 ? "nas" : "mnie",
            bank:
              bankAddressDb === undefined
                ? "(uzupełnij)"
                : bankNext === "nie dotyczy"
                ? bankAddressDb.nameLetter
                : bankAddressDb.nameLetter +
                  ", jako następcy prawnemu " +
                  bankNext,
            credit_number: aggCreditNumber
              ? aggCreditNumber
              : ".......................................",
            credit_date:
              aggCreditDate.length > 0 && aggCreditDate !== "undefined"
                ? (new Date(aggCreditDate).getDate() < 10
                    ? "0" + new Date(aggCreditDate).getDate()
                    : new Date(aggCreditDate).getDate()) +
                  " " +
                  getMonthName(new Date(aggCreditDate).getMonth() + 1) +
                  " " +
                  new Date(aggCreditDate).getFullYear() +
                  " roku"
                : ".......................................",
          });
          try {
            doc.render();
          } catch (error) {
            function replaceErrors(key, value) {
              if (value instanceof Error) {
                return Object.getOwnPropertyNames(value).reduce(function (
                  error,
                  key
                ) {
                  error[key] = value[key];
                  return error;
                },
                {});
              }
              return value;
            }

            if (error.properties && error.properties.errors instanceof Array) {
              const errorMessages = error.properties.errors
                .map(function (error) {
                  return error.properties.explanation;
                })
                .join("\n");
            }
            throw error;
          }
          var out = doc.getZip().generate({
            type: "blob",
            mimeType:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          saveAs(out, "Pełnomocnictwo" + "_" + generateName() + ".docx");

          MySwal.fire({
            title: "Pełnomocnictwo: czy chcesz zapisać pismo w systemie?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then(async (result) => {
            if (result.isConfirmed) {
              let formData = new FormData();
              formData.append("file", out);
              formData.append("type", "sell");
              formData.append("leadId", props.leadData.id);
              formData.append("user", props.user);
              formData.append("name", "Pełnomocnictwo" + "_" + generateName());

              await fetch("https://apidevkppp.ftpeople.pl/uploadSellFile1", {
                method: "POST",
                body: formData,
              })
                .then((response) => {})
                .then((responseJson) => {
                  generateAggr2();
                });
            } else if (result.isDenied) {
              generateAggr2();
            }
          });
        });
      }
    });
  };

  const generateAgValue = () => {
    if (aggFirstPayDate.length === 0) {
      var text =
        (aggValue === "" ? "....." : aggValue) +
        " zł, płatną w " +
        (aggInstallment === "" ? "....." : aggInstallment) +
        " ratach po " +
        (aggValue === "" ? "....." : (aggValue / aggInstallment).toFixed(2)) +
        " zł w terminach:\n";
      if (aggInstallment === "") {
        text =
          text +
          "1. rata do dnia " +
          30 +
          " " +
          getMonthName(new Date().getMonth() + 1) +
          " " +
          new Date().getFullYear() +
          " roku";
      }
      return text;
    }
    if (+aggInstallment > 1 || aggInstallment === "") {
      var text =
        (aggValue === "" ? "....." : aggValue) +
        " zł, płatną w " +
        (aggInstallment === "" ? "....." : aggInstallment) +
        " ratach po " +
        (aggValue === "" ? "....." : (aggValue / aggInstallment).toFixed(2)) +
        " zł w terminach:\n";

      if (aggInstallment === "") {
        text =
          text +
          "1. rata do dnia " +
          30 +
          " " +
          getMonthName(new Date().getMonth() + 1) +
          " " +
          new Date().getFullYear() +
          " roku";
      } else {
        try {
          for (var i = 0; i < +aggInstallment; ++i) {
            text =
              text +
              "- " +
              (i + 1) +
              ". rata do dnia " +
              (new Date(aggFirstPayDate).getDate() < 10
                ? "0" + new Date(aggFirstPayDate).getDate()
                : new Date(aggFirstPayDate).getDate()) +
              " " +
              getMonthName(
                new Date(aggFirstPayDate).getMonth() + 1 + i > 12
                  ? new Date(aggFirstPayDate).getMonth() + 1 + i - 12
                  : new Date(aggFirstPayDate).getMonth() + 1 + i
              ) +
              " " +
              (new Date(aggFirstPayDate).getMonth() + 1 + i > 12
                ? new Date(aggFirstPayDate).getFullYear() + 1
                : new Date(aggFirstPayDate).getFullYear()) +
              " roku" +
              "\n";
          }
        } catch (err) {}
      }

      return text;
    } else if (+aggInstallment === 1) {
      return (
        aggValue +
        " zł, płatną w terminie " +
        (aggFirstPayDate
          ? (new Date(aggFirstPayDate).getDate() < 10
              ? "0" + new Date(aggFirstPayDate).getDate()
              : new Date(aggFirstPayDate).getDate()) +
            " " +
            getMonthName(new Date(aggFirstPayDate).getMonth() + 1) +
            " " +
            new Date(aggFirstPayDate).getFullYear() +
            " roku"
          : ".......................................")
      );
    } else {
      return ".......................................";
    }
  };

  const generateAggr2 = () => {
    var model = [];

    letters
      .filter((el) => el.type === "umowa")
      .map((element) => {
        model[element.link] = element.name;
      });

    MySwal.fire({
      title: "Wybierz wzór umowy",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wzór",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wzór");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var link = result.value;
        loadFile(link, function (error, content) {
          if (error) {
            throw error;
          }
          var zip = new PizZip(content);
          var doc = new Docxtemplater(zip, {
            paragraphLoop: true,
            linebreaks: true,
          });

          doc.setData({
            date:
              (new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : new Date().getDate()) +
              " " +
              getMonthName(new Date().getMonth() + 1) +
              " " +
              new Date().getFullYear() +
              " roku",
            hasName: clientsE.length === 0 ? false : true,
            empty_name:
              clientsE.length === 0
                ? "Imię i nazwisko: ............................................................\nadres zamieszkania: ............................................................\n" +
                  "\n\n" +
                  "Imię i nazwisko: ............................................................\nadres zamieszkania: ............................................................\n"
                : "",
            petitioner_data: getPetitionerData(),
            bank:
              bankAddressDb === undefined
                ? "(uzupełnij)"
                : bankNext === "nie dotyczy"
                ? bankAddressDb.nameLetter
                : bankAddressDb.nameLetter +
                  ", jako następcy prawnemu " +
                  bankNext,
            credit_number: aggCreditNumber
              ? aggCreditNumber
              : ".......................................",
            credit_date:
              aggCreditDate.length > 0 && aggCreditDate !== "undefined"
                ? (new Date(aggCreditDate).getDate() < 10
                    ? "0" + new Date(aggCreditDate).getDate()
                    : new Date(aggCreditDate).getDate()) +
                  " " +
                  getMonthName(new Date(aggCreditDate).getMonth() + 1) +
                  " " +
                  new Date(aggCreditDate).getFullYear() +
                  " roku"
                : ".......................................",
            mail: mail,
            phone: phone,
            sf_value: aggSfValue === "" ? "....." : aggSfValue,
            sf_ug_value: aggSfUgValue === "" ? "....." : aggSfUgValue,
            ag_value: generateAgValue(),
          });
          try {
            doc.render();
          } catch (error) {
            function replaceErrors(key, value) {
              if (value instanceof Error) {
                return Object.getOwnPropertyNames(value).reduce(function (
                  error,
                  key
                ) {
                  error[key] = value[key];
                  return error;
                },
                {});
              }
              return value;
            }

            if (error.properties && error.properties.errors instanceof Array) {
              const errorMessages = error.properties.errors
                .map(function (error) {
                  return error.properties.explanation;
                })
                .join("\n");
            }
            throw error;
          }
          var out = doc.getZip().generate({
            type: "blob",
            mimeType:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          saveAs(out, "Umowa na pomoc prawną" + "_" + generateName() + ".docx");

          MySwal.fire({
            title: "Umowa: czy chcesz zapisać pismo w systemie?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then(async (result) => {
            if (result.isConfirmed) {
              let formData = new FormData();
              formData.append("file", out);
              formData.append("type", "sell");
              formData.append("leadId", props.leadData.id);
              formData.append("user", props.user);
              formData.append(
                "name",
                "Umowa na pomoc prawną" + "_" + generateName()
              );

              await fetch("https://apidevkppp.ftpeople.pl/uploadSellFile1", {
                method: "POST",
                body: formData,
              })
                .then((response) => {})
                .then((responseJson) => {
                  MySwal.fire({
                    icon: "success",
                    title: "Wygenerowano",
                    text: "dokumenty",
                  }).then(async (result) => {
                    props.close();
                  });
                });
            } else if (result.isDenied) {
              MySwal.fire({
                icon: "success",
                title: "Wygenerowano",
                text: "dokumenty",
              }).then(async (result) => {
                props.close();
              });
            }
          });
        });
      }
    });
  };

  const generateDocs = (e) => {
    if (!validate()) {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
      return;
    }

    var body = {
      id: props.leadData.id,
      phone: phone,
      mail: mail,
      bank: bank,
      aggName: clientsE.length > 0 ? generateName() : "",
      aggAdditionalData: additionalData,
      aggValue: aggValue,
      aggInstallment: aggInstallment,
      aggSFValue: aggSfValue,
      aggSFUgValue: aggSfUgValue,
      aggFirstPayDate: aggFirstPayDate,
      aggNextBank: bankNext,
      aggCreditNumber: aggCreditNumber,
      aggCreditDate: aggCreditDate,
      aggCreditValue: +aggCreditValue > 0 ? aggCreditValue : 0,
    };

    fetch("https://apidevkppp.ftpeople.pl/updateLeadAgg", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((responseJson) => {
        generateAggr1();
      });
  };

  const handleBankChange = (e) => {
    setBank(e.target.value);
    setBankNext("nie dotyczy");
    setBanksAggrNew(banksAggr.filter((el) => el.bank === e.target.value));
    setBankAddressDb(
      bankAddressDbAll.filter((el) => el.nameSelect === e.target.value)[0]
    );
  };

  return (
    <div
      style={{
        width: "45vw",
        top: "5vh",
        maxHeight: "80vh",
        overflowY: "scroll",
      }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div style={{ textTransform: "uppercase", fontSize: "1.5vw" }}>
            Wygeneruj umowę i pełn.
          </div>

          {showEditClientAdditionalData ? (
            <EditClientAdditionalData
              close={closeEditAdditionalData}
              logClientAction={props.logClientAction}
              client={{ petitioner: generateName() }}
              tabIndex={""}
              additionalData={additionalData}
              setAdditionalData={setAdditionalData}
              mode={"add"}
            />
          ) : (
            ""
          )}

          <div className="inputBox">
            <div className="inputCol_2">
              <label>Imię i nazwisko klienta</label>
              <input
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={handleNameChange}
              />
            </div>
            <div id="col2AddUser" className="inputCol_2">
              <button
                id="addButton"
                className="acceptButton"
                value={name}
                onClick={handleAddClient}
                style={{
                  backgroundColor: "red",
                  color: "white",
                  border: "none",
                }}
              >
                DODAJ
              </button>
            </div>
          </div>

          {clientsE.length > 0 ? (
            <div className="colClient">
              {clientsE.map((el) => (
                <>
                  <div className="rowClient">
                    <div className="rowClient_col1">{el}</div>
                    <div className="rowClient_col2">
                      <button
                        id="addButton"
                        className="acceptButton"
                        value={el}
                        onClick={handleDeleteClient}
                        style={{
                          backgroundColor: "#00bdce",
                          color: "white",
                          border: "none",
                        }}
                      >
                        USUŃ
                      </button>
                    </div>
                  </div>
                </>
              ))}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <button
                  className="acceptButton"
                  style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                  onClick={(e) => {
                    setShowEditClientAdditionalData(true);
                  }}
                  style={{
                    backgroundColor: "#00bdce",
                    color: "white",
                    border: "none",
                    marginTop: "2vh",
                  }}
                >
                  Wprowadź adres i pesel
                </button>
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="inputBox">
            <div className="inputCol_3" style={{ marginTop: "1vh" }}>
              <label>Bank</label>

              <select
                type="text"
                id="court"
                name="court"
                value={bank}
                onChange={handleBankChange}
              >
                {bank === "" ? (
                  <option key={0} value={""}>
                    {"Wybierz..."}
                  </option>
                ) : (
                  ""
                )}
                {banks
                  .filter((el1) => el1.team.includes("1"))
                  .map((el) => (
                    <option key={el.id} value={el.name}>
                      {el.name}
                    </option>
                  ))}
              </select>
            </div>

            <div className="inputCol_3" style={{ marginTop: "1vh" }}>
              <label>Bank umowa</label>
              <select
                type="text"
                id="court"
                name="court"
                value={bankNext}
                onChange={(e) => setBankNext(e.target.value)}
              >
                {bankNext === "" ? (
                  <option key={0} value={""}>
                    {"Wybierz..."}
                  </option>
                ) : (
                  ""
                )}
                <option key={1} value={""}>
                  {"Nie dotyczy"}
                </option>
                {banksAggrNew.map((el) => (
                  <option key={1} value={el.bankOld}>
                    {el.bankOld}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="inputBox">
            <div className="inputCol_3" style={{ marginTop: "1vh" }}>
              <label>Adres e-mail</label>
              <input
                type="text"
                id="name"
                name="name"
                value={mail}
                onChange={(e) => setMail(e.target.value)}
              />
            </div>

            <div className="inputCol_3" style={{ marginTop: "1vh" }}>
              <label>Numer telefonu</label>
              <input
                type="text"
                id="name"
                name="name"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
          </div>

          <div className="inputBox">
            <div className="inputCol_3" style={{ marginTop: "1vh" }}>
              <label>Kwota wynagrodzenia</label>
              <input
                type="number"
                id="name"
                name="name"
                value={aggValue}
                onChange={(e) => setAggValue(e.target.value)}
                onKeyPress={(e) =>
                  !/^\d*\,?\d*$/.test(e.key) && e.preventDefault()
                }
              />
            </div>

            <div className="inputCol_3" style={{ marginTop: "1vh" }}>
              <label>Ilość rat</label>
              <input
                type="number"
                id="name"
                name="name"
                value={aggInstallment}
                onChange={(e) => setAggInstallment(e.target.value)}
                onKeyPress={(e) =>
                  !/^\d*\,?\d*$/.test(e.key) && e.preventDefault()
                }
              />
            </div>
          </div>

          <div className="inputBox">
            <div className="inputCol_3" style={{ marginTop: "1vh" }}>
              <label>Data pierwszej płatności</label>
              <input
                type="date"
                id="name"
                name="name"
                value={aggFirstPayDate}
                onChange={(e) => setAggFirstPayDate(e.target.value)}
              />
            </div>

            <div className="inputCol_3" style={{ marginTop: "1vh" }}>
              <label>Success fee (%)</label>
              <input
                type="number"
                id="name"
                name="name"
                value={aggSfValue}
                onChange={(e) => setAggSfValuet(e.target.value)}
                onKeyPress={(e) =>
                  !/^\d*\,?\d*$/.test(e.key) && e.preventDefault()
                }
              />
            </div>
          </div>

          <div className="inputBox">
            <div className="inputCol_3" style={{ marginTop: "1vh" }}>
              <label>Data umowy kredytowej</label>
              <input
                type="date"
                id="name"
                name="name"
                value={aggCreditDate}
                onChange={(e) => setAggCreditDate(e.target.value)}
              />
            </div>
            {false ? (
              <div className="inputCol_3" style={{ marginTop: "1vh" }}>
                <label>Wartość kredytu</label>
                <input
                  type="number"
                  id="name"
                  name="name"
                  value={aggCreditValue}
                  onChange={(e) => setAggCreditValue(e.target.value)}
                  onKeyPress={(e) =>
                    !/^\d*\,?\d*$/.test(e.key) && e.preventDefault()
                  }
                />
              </div>
            ) : (
              ""
            )}
            <div className="inputCol_3" style={{ marginTop: "1vh" }}>
              <label>Numer umowy kredytowej</label>
              <input
                type="text"
                id="name"
                name="name"
                value={aggCreditNumber}
                onChange={(e) => setAggCreditNumber(e.target.value)}
              />
            </div>
          </div>

          <div style={{ display: "none" }} className="inputBox">
            <div className="inputCol_3" style={{ marginTop: "1vh" }}>
              <label>Success fee ugoda (%)</label>
              <input
                type="number"
                id="name"
                name="name"
                value={aggSfUgValue}
                onChange={(e) => setAggSfUgValue(e.target.value)}
                onKeyPress={(e) =>
                  !/^\d*\,?\d*$/.test(e.key) && e.preventDefault()
                }
              />
            </div>
            <div className="inputCol_3" style={{ marginTop: "1vh" }}></div>
          </div>

          <button
            id="addButton"
            className="acceptButton"
            value={""}
            onClick={generateDocs}
            style={{
              backgroundColor: "#00bdce",
              color: "white",
              border: "none",
              marginTop: "3vh",
              width: "50%",
            }}
          >
            WYGENERUJ
          </button>
        </>
      )}
    </div>
  );
};

export default AddAggr;
